"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadCostSearchFilterEntity = void 0;
function parseILeadCostSearchFilterEntity(data) {
    if (typeof data.valid_from_date === 'string')
        data.valid_from_date = new Date(data.valid_from_date);
    if (typeof data.valid_to_date === 'string')
        data.valid_to_date = new Date(data.valid_to_date);
    return data;
}
exports.parseILeadCostSearchFilterEntity = parseILeadCostSearchFilterEntity;
